module.exports = __webpack_public_path__ + "static/media/privacy-photo3-3.ba1b9d3a.png";